import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useSelector, useDispatch } from 'react-redux';

import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
// @mui
import { Stack, Button, Typography, Skeleton, Grid, Select, MenuItem, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CityReqTable } from '../sections/@dashboard/LandsList';

import { hasPermission } from '../utils/permissions';
import Layout from '../components/Layout/Layout';
import SearchComponet from '../components/search/Search';
import { ReactComponent as DropdownIcon } from '../theme/images/deopdownIcon.svg';
import { resetFormData } from '../Store/features/Lands/landsSlice';

import { getLandsList, deleteRegion } from '../network/apis';

export default function Plans() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [clientReqList, setClientReqList] = useState([]);
  const [search, setSearch] = useState('');
  const [status, setChangeStatus] = useState('');
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const handleChange = (e) => {
    setChangeStatus(e.target.value);
  };

  const clientRequests = (page, search, status) => {
    setLoading(true);
    getLandsList(page, search, status)
      .then((res) => {
        setClientReqList(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    clientRequests(page, search, status);
  }, [page, search, status]);
  useEffect(() => {
    dispatch(resetFormData());
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleDelete = (id) => {
    deleteRegion(id)
      .then((res) => {
        if (res.data.STATUS === 'FAILED') {
          toast.error(res.data.MESSAGE);
        } else toast.success(res.data.MESSAGE);
        // Reload the cities list
        clientRequests(page, search);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.MESSAGE);
      });
  };

  const handleOpenModal = () => {
    navigate('/dashboard/land/add');
  };

  const sideMenu = useSelector((state) => state.login?.sideMenu || []);
  const hasSearchPermission = hasPermission(sideMenu, '/dashboard/lands', 'Search for Land');
  const hasAddPermission = hasPermission(sideMenu, '/dashboard/lands', 'Add Land');
  const hasEditPermission = hasPermission(sideMenu, '/dashboard/lands', 'Edit land Details ');
  return (
    <>
      <Helmet>
        <title> {t('LANDS.lands')} </title>
      </Helmet>

      <Layout>
        <Grid marginBottom={1} display="flex" alignItems={'center'} justifyContent="space-between" md={6} xs={12}>
          <Typography sx={{ fontSize: '24px', fontWeight: '700', lineHeight: '32px', color: '#111827' }}>
            {t('LANDS.lands')}
          </Typography>
          {hasAddPermission && (
            <Button
              onClick={handleOpenModal}
              style={{
                backgroundColor: 'black',
                color: 'white',
                borderRadius: '10px',
                padding: '21px 24px',
                width: '164px',
                height: '56px',
              }}
            >
              {' '}
              <Typography sx={{ display: 'flex', gap: 1 }}>
                <span> + </span> <span>{t('LANDS.addLand')}</span>
              </Typography>
            </Button>
          )}
        </Grid>
        <Grid mb={2} rowSpacing={2} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {hasSearchPermission && (
            <Grid item xs={2} sm={4} md={4}>
              <SearchComponet onSearch={setSearch} style={{ width: '100%' }} />
            </Grid>
          )}
          <Grid item xs={2} sm={4} md={4}>
            <Grid>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={status}
                  sx={{
                    paddingLeft: isRtl ? '10px' : '0px',
                    paddingRight: isRtl ? '0px' : '10px',
                  }}
                  renderValue={(selected) => {
                    if (selected === '') {
                      return <span>{t('General.AllStatus')}</span>;
                    }
                    if (selected === 'FREE') return <span>{t('Units.available')}</span>;
                    if (selected === 'RESERVED') return <span>{t('Units.reserved')}</span>;
                    if (selected === 'SOLD') return <span>{t('Units.sold')}</span>;
                    return <span style={{ color: '#9e9e9e' }}>{t('General.select')}</span>;
                  }}
                  IconComponent={() => <DropdownIcon style={{ width: '15px', height: '15px' }} />}
                  labelId="Status"
                  id="status"
                  onChange={handleChange}
                >
                  <MenuItem value="">{t('General.AllStatus')}</MenuItem>
                  <MenuItem value="FREE"> {t('Units.available')}</MenuItem>
                  <MenuItem value="RESERVED">{t('Units.reserved')}</MenuItem>
                  <MenuItem value="SOLD">{t('Units.sold')}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        {loading ? (
          <Stack>
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
          </Stack>
        ) : (
          <>
            <>
              <CityReqTable
                handleChangePage={handleChangePage}
                page={page}
                hasEditPermission={hasEditPermission}
                hasAddPermission={hasAddPermission}
                requests={clientReqList}
                onDelete={handleDelete}
              />
            </>
          </>
        )}
      </Layout>
    </>
  );
}
